import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "components/atoms/Button";
import FormInput from "components/atoms/FormInput";
import PageTitle from "components/atoms/PageTitle";
import Alert from "components/atoms/Alert";
import { postRequest, BASE_URL, loggedUser_baseURL } from "services/http";
import { connect } from "react-redux";
import { setAuthRes } from "../../../redux/auth/auth.action";

import forgotPasskey from "../../../assets/svg/forgotPassKey.svg";
import verify_ticked from "../../../assets/svg/verify_ticked.svg";
import verify_unticked from "../../../assets/svg/verify_unticked.svg";
import showPwd from "../../../assets/svg/show.svg";
import hidePwd from "../../../assets/svg/hide.svg";
import arrowLeft from "../../../assets/svg/larrow-left-long.svg";
import checkIcon from "../../../assets/svg/checkIcon.svg";
import Spinner from "components/atoms/Spinner";
import CodeInput from "components/atoms/CodeInput";

const CreateNewPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [passwdValid, setPasswdValid] = useState(false);
  const [passwdFormatValid, setPasswdFormatValid] = useState(false);
  const [passwdFormatValid2, setPasswdFormatValid2] = useState(false);
  const [newPasswdValid, setNewPasswdValid] = useState(false);
  const [newPasswdConfirmed, setNewPasswdConfirmed] = useState(false);
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [newPasswordErr, setNewPasswordErr] = useState("");
  const [showErrMssg_passwd, setShowErrMssg_passwd] = useState(false);
  const [showErrMssg_confirmPasswd, setShowErrMssg_confirmPasswd] =
    useState(false);
  const [selectBox, setselectBox] = useState(false);
  const [progressData, setProgressData] = useState<any>([]);
  const [OTPChange, setOTPChange] = useState("");
  const [newValidPassword, setNewValidPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const recoveryMail =
    location?.state?.recoveryEmail === undefined ? false : true;

  const queryParams = new URLSearchParams(location.search);
  const partnerEmail = decodeURIComponent(
    queryParams.get("email")?.replaceAll(" ", "+") || ""
  ); // Fetch the email parameter;
  const partnerType = queryParams.get("partnerType"); // Fetch the partnerType parameter
  const newUser = queryParams.size !== 0;

  useEffect(() => {
    if (queryParams.size === 0) {
      if (!recoveryMail) {
        Alert("error", "Enter recovery email");
        navigate("/auth/forgot_password");
      }
    }
  }, []);
  // }, [navigate, location]);

  const handlePasswordChange = (e) => {
    if (showErrMssg_passwd) setShowErrMssg_passwd(false);

    const specialChar = /[^A-Za-z0-9\s]/;
    const capitalLetter = /[A-Z]/;

    const value = e.target.value;
    setPassword(value);

    setPasswdValid(value.length >= 8);
    setPasswdFormatValid(specialChar.test(value));
    setPasswdFormatValid2(capitalLetter.test(value));
  };

  const handleNewPasswordChange = (e) => {
    if (showErrMssg_confirmPasswd) setShowErrMssg_confirmPasswd(false);

    const value = e.target.value;
    setNewPassword(value);

    setNewPasswdConfirmed(true);
    setTimeout(() => setNewPasswdConfirmed(false), 5000);

    setNewPasswdValid(value === password);
  };

  const resetPassword = useCallback(
    async (reqData) => {
      setLoading(true);
      const headers = { "Content-Type": "application/json" };
      const res = await postRequest(
        `${BASE_URL}auth/password/set`,
        headers,
        reqData
      );

      if (res?.data.status === "SUCCESS") {
        Alert("success", res?.data.message);
        const loginData = {
          email: partnerEmail,
          password: newPassword,
        };

        await validationFunc(loginData);
      } else {
        setLoading(false);
        Alert("error", res?.data?.message || "Error: Something went wrong");
      }
    },
    [partnerEmail, newPassword]
  );

  const changePassword = async (reqData: any) => {
    setLoading(true);
    const headers = { "Content-Type": "application/json" };
    const res = await postRequest(`${BASE_URL}auth/reset`, headers, reqData);

    if (res?.data.status === "SUCCESS") {
      Alert("success", res?.data.message);
      setNewValidPassword(true);
      setTimeout(
        () =>
          navigate("/auth/password_reset", {
            state: { newPassword: newValidPassword },
          }),
        2000
      );
      // navigate('/auth/login');
      setLoading(false);
    } else {
      setLoading(false);
      Alert("error", res?.data?.message || "Error: Something went wrong");
    }
  };

  const validationFunc = useCallback(
    async (reqData) => {
      const headers = { "Content-Type": "application/json" };
      const res = await postRequest(`${BASE_URL}auth/login`, headers, reqData);

      if (res?.data.responseCode === "00") {
        props.setAuthRes(res.data.data);
        const termsData = {
          email: partnerEmail,
          tAndC: selectBox,
        };
        await checkTermsAndConditions(res.data.data.token.token, termsData);
      } else {
        Alert("error", partnerEmail + ": " + res?.data.message);
        setLoading(false);
      }
    },
    [partnerEmail, selectBox]
  );

  const checkTermsAndConditions = useCallback(
    async (token, reqData) => {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
      const res = await postRequest(
        `${BASE_URL}${loggedUser_baseURL}terms-conditions`,
        headers,
        reqData
      );

      if (res?.data.responseCode === "00") {
        setTimeout(() => navigate("/auth/kyc_info"), 3000);
        setLoading(false);
      } else {
        setLoading(false);
      }
    },
    [navigate]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!passwdValid || !passwdFormatValid || !passwdFormatValid2) {
      setPasswordErr("Password must meet all conditions.");

      setShowErrMssg_passwd(true);
      return;
    }

    if (password !== newPassword) {
      setNewPasswordErr("Passwords do not match!");

      setShowErrMssg_confirmPasswd(true);
      return;
    }

    if (newUser) {
      const reqData = { email: partnerEmail, password: newPassword };
      await resetPassword(reqData);
    } else {
      const reqData = {
        email: location?.state?.recoveryEmail,
        newPassword: newPassword,
        otp: OTPChange,
      };
      await changePassword(reqData);
    }
  };

  const formComplete = newUser
    ? password && newPassword && selectBox
    : password && newPassword;

  const disabledBtn = !formComplete || loading;

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <img
          src={forgotPasskey}
          alt="SeerbitLogo"
          className="w-[40px] h-[40px]"
        />
        <PageTitle
          pageTitle="Create a new password"
          pageTitleStyle="font-semibold !text-2xl tablet:!text-xl"
          subTitle="Your new password must be different to previously used passwords."
          subTitleStyle="!text-sm leading-7 !text-Black2"
          style="!m-0 !p-0"
        />
      </div>
      <span className="flex flex-col gap-3">
        {!newUser && (
          <CodeInput
            label="Enter the OTP you just received in your mail"
            labelStyle="font-normal text-sm leading-6 text-Black2"
            length={6}
            onChange={(v) => setOTPChange(v)}
            type={"numeric"}
            secret={false}
            onComplete={(p) => setOTPChange(p)}
          />
        )}
        <div className="flex-col items-start justify-between gap-3">
          <FormInput
            type={showPassword ? "text" : "password"}
            name="passwd"
            style="w-full"
            placeholder="********"
            inputStyle="border border-transparent text-Black2 flex-row-reverse"
            label="New Password"
            labelStyle="font-normal text-sm leading-6 text-Black2"
            onChange={handlePasswordChange}
            value={password}
            validationErr={showErrMssg_passwd && passwordErr}
            img={showPassword ? showPwd : hidePwd}
            imgStyle="cursor-pointer w-4 h-4 block"
            imgOnClick={() => setShowPassword((prevState) => !prevState)}
          />
          <FormInput
            type={showNewPassword ? "text" : "password"}
            name="passwd"
            style="w-full"
            placeholder="********"
            inputStyle={`border ${
              newPasswdConfirmed && newPasswdValid
                ? "text-Success border-Success"
                : newPasswdConfirmed && !newPasswdValid
                ? "text-PrimaryActive border-PrimaryActive"
                : "text-Black2 border-transparent"
            } transition-all flex-row-reverse`}
            label="Confirm Password"
            labelStyle="font-normal text-sm leading-6 text-Black2"
            onChange={handleNewPasswordChange}
            value={newPassword}
            validationErr={showErrMssg_confirmPasswd && newPasswordErr}
            img={showNewPassword ? showPwd : hidePwd}
            imgStyle="cursor-pointer w-4 h-4 block"
            imgOnClick={() => setShowNewPassword((prevState) => !prevState)}
          />
        </div>
      </span>

      <div className="flex flex-col gap-1">
        <span className="flex items-center justify-start gap-2 text-sm font-normal text-Black2">
          <img
            src={passwdValid ? verify_ticked : verify_unticked}
            alt="arrowLeft"
            className="w-4 h-4"
          />
          Must be at least 8 characters
        </span>
        <span className="flex items-center justify-start gap-2 text-sm font-normal text-Black2">
          <img
            src={passwdFormatValid2 ? verify_ticked : verify_unticked}
            alt="arrowLeft"
            className="w-4 h-4"
          />
          Must contain one Capital letter
        </span>
        <span className="flex items-center justify-start gap-2 text-sm font-normal text-Black2">
          <img
            src={passwdFormatValid ? verify_ticked : verify_unticked}
            alt="arrowLeft"
            className="w-4 h-4"
          />
          Must contain one special character
        </span>
        <span className="flex items-center justify-start gap-2 text-sm font-normal text-Black2">
          <img
            src={
              newPassword === password && password !== ""
                ? verify_ticked
                : verify_unticked
            }
            alt="arrowLeft"
            className="w-4 h-4"
          />
          Password Match
        </span>
      </div>

      <div className="flex flex-col gap-3">
        <div
          className={`${
            newUser ? "flex" : "hidden"
          } items-start justify-start gap-2 border p-2 rounded-md`}
        >
          <span
            className="flex flex-shrink-0 border border-gray-400 rounded-[4px] w-4 h-4 overflow-hidden p-[.5px] cursor-pointer"
            onClick={() => setselectBox((prevState) => !prevState)}
          >
            {selectBox && (
              <span className="w-full h-full bg-DarkBg3 rounded-[3px] flex justify-center items-center">
                <img src={checkIcon} alt="checkIcon" className="w-4/5 h-4/5" />
              </span>
            )}
          </span>

          <span>
            By checking this box, you confirm that you’ve read and agreed to our{" "}
            <a
              href="https://www.seerbit.com/acceptable-use-policy?_gl=1*mhze0y*_gcl_au*MjE5Njg0ODk4LjE3NjYxMzg1NDA."
              className="underline cursor-pointer"
            >
              Terms and Conditions.
            </a>
          </span>
        </div>
        <Button
          btnType="submit"
          btnText={
            loading ? (
              <Spinner text="Processing..." textStyle="text-white" />
            ) : (
              "Proceed"
            )
          }
          btnStyle={`${
            disabledBtn ? "cursor-not-allowed" : ""
          } bg-black text-white px-6 py-3 w-full`}
          disabled={disabledBtn}
        />
      </div>
      <Link
        to="/auth/login"
        className="flex items-center justify-start gap-3 mt-1 text-sm font-semibold leading-7 text-black cursor-pointer hover:underline hover:transition-all"
      >
        <img src={arrowLeft} alt="arrowLeft" className="w-4 h-4" />
        Back to Login
      </Link>
    </form>
  );
};

export default connect(null, { setAuthRes })(CreateNewPassword);
